export const PAGE_SIZE_KEY = "page_size"
export const ACCESS_TOKEN_KEY = "accessToken"

export const localStorage = typeof window !== "undefined" ? window.localStorage : null